import { useEffect, useRef, useState } from 'react';
import './cursorFollower.css';

export default function CursorFollower() {
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const mousePos = useRef({ x: 0, y: 0 });
  const outerPos = useRef({ x: 0, y: 0 });
  const innerPos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      setIsTouchDevice(true);
      return;
    }

    const handleMouseMove = (e) => {
      mousePos.current = { x: e.clientX, y: e.clientY };
    };

    const handleMouseOver = (e) => {
      if (e.target.closest('a, button, label')) {
        outerRef.current?.classList.add('hovered');
      }
    };

    const handleMouseOut = (e) => {
      if (e.target.closest('a, button, label')) {
        outerRef.current?.classList.remove('hovered');
      }
    };

    const handleClick = () => {
      outerRef.current?.classList.remove('hovered');
    };

    const animate = () => {
      outerPos.current.x += (mousePos.current.x - outerPos.current.x) * 0.15;
      outerPos.current.y += (mousePos.current.y - outerPos.current.y) * 0.15;

      innerPos.current.x += (mousePos.current.x - innerPos.current.x) * 0.05;
      innerPos.current.y += (mousePos.current.y - innerPos.current.y) * 0.05;

      if (outerRef.current) {
        outerRef.current.style.left = `${outerPos.current.x}px`;
        outerRef.current.style.top = `${outerPos.current.y}px`;
      }

      if (innerRef.current) {
        innerRef.current.style.left = `${innerPos.current.x}px`;
        innerRef.current.style.top = `${innerPos.current.y}px`;
      }

      requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('mouseout', handleMouseOut);
    window.addEventListener('click', handleClick);
    animate();

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('mouseout', handleMouseOut);
      window.removeEventListener('click', handleClick);
    };
  },[]);

// Hide on touchscreens
  if (isTouchDevice) return null;

  return (
    <>
      <div
        className='cursor-follower outer' 
        ref={outerRef}>
      </div>
      <div 
        className='cursor-follower inner' 
        ref={innerRef}>
      </div>
    </>
  );
}
